import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { LocalService, StatusWithId, KeyValueSet, Wrapper10Initialization, Wrappers10, Paging, KeyValues3, KeyValues5, TaskStatus, KeyValues30, TaskUpdateType } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class TaskManagementService {
  private controllerName = service_controllers_methods.tasks.controller;
  private methods = service_controllers_methods.tasks.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public getTaskRequestsInitialization(filterData: KeyValues5): Observable<Wrapper10Initialization> {
    const body = {
      sel: this.localService.getSelected(),
      dt: filterData
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetTaskRequestsInitialization, body);
  }

  public getTaskRequests(filterData: KeyValues5, paging: Paging): Observable<Wrappers10> {
    const body = {
      sel: this.localService.getSelected(),
      pag: paging,
      dt: filterData
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetTaskRequests, body);
  }

  public getTaskRequest(taskId: string, parentTaskNumber: string): Observable<KeyValues30> {
    const body = {
      sel: this.localService.getSelected(),
      dt: { v1: taskId, v2: parentTaskNumber } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetTaskRequest, body);
  }

  public createTaskRequest(data: KeyValues30): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.CreateTaskRequest, body);
  }

  public getTaskOwners(): Observable<KeyValueSet[]> {
    const body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetTaskOwners, body);
  }

  public updateTaskStatus(taskId: string, toTaskStatus: TaskStatus, comment?: string): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: { v1: taskId, v2: toTaskStatus.toString(), v3: comment } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateTaskStatus, body);
  }

  public updateTaskRequest(data: KeyValues30, taskUpdateType: TaskUpdateType): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: data,
      dt1: { v1: taskUpdateType.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateTaskRequest, body);
  }

  public sendTaskRequestAlerts(): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SendTaskRequestAlerts, body);
  }
}
